import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { LocalStorageService } from 'src/app/_services/localStorage/local-storage.service';

@Component({
  selector: 'app-goal-profile',
  templateUrl: './goal-profile.component.html',
  styleUrls: ['./goal-profile.component.scss']
})
export class GoalProfileComponent implements OnInit {
  tenantId: string;
  currentUser: any;
  isHRAdmin: boolean;

  constructor(
    private storageService: LocalStorageService,
    private router: Router,
  ) { }

  ngOnInit(): void {
    this.currentUser = JSON.parse(this.storageService.get('currentUser'));
    this.tenantId = this.storageService.get('tenantId');
    this.isHRAdmin = this.currentUser.roles.includes('RoleHrmAdministrator');
  }

  myperformance(){
    this.router.navigate([this.tenantId + '/dashboard/hr/goal-profile-hr/goal']);
  }

  OverallPerformance(){
    this.router.navigate([this.tenantId + '/dashboard/hr/goal-profile-hr/goal-hrpage']);
  }

  OpenSkillMatrix(){
    this.router.navigate([this.tenantId + '/dashboard/hr/goal-profile-hr/skill-matrix']);
  }
}
